let SpinnerSize = /*#__PURE__*/function (SpinnerSize) {
  SpinnerSize[SpinnerSize["xxSmall"] = -1] = "xxSmall";
  SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
  SpinnerSize[SpinnerSize["small"] = 1] = "small";
  SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
  SpinnerSize[SpinnerSize["large"] = 3] = "large";
  return SpinnerSize;
}({});

const SPINNER_SIZES_MAP = {
  [SpinnerSize.xxSmall]: 8,
  [SpinnerSize.xSmall]: 24,
  [SpinnerSize.small]: 32,
  [SpinnerSize.medium]: 48,
  [SpinnerSize.large]: 64
};
const getSpinnerSize = spinnerSize => `${SPINNER_SIZES_MAP[spinnerSize] || SPINNER_SIZES_MAP[SpinnerSize.medium]}px`;

export { SpinnerSize as S, getSpinnerSize as g };
